<template>
    <div class='container_wrap'>
        <div class="top-title-box">
            <div>勘察报告</div>
            <div>创建时间：2022/04/18</div>
        </div>
        <div class="content-box">
            <div class="report-content">
                <div class="navbar-box">
                    <div class="navbar-item flc" :class="{'active-item': currentIndex == index }" v-for="(item,index) in navbarList" @click="navbarChange(index)" :key="index">{{item.name}}</div>
                    <div class="bottom-slider" :style="{left:currentIndex * 50 + 25 + '%'}"></div>
                </div>
                <transition name="navContent" mode="out-in">
                    <div v-if="currentIndex == 0" key="info">
                        <info></info>
                    </div>
                    <div v-if="currentIndex == 1">
                        <position></position>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>

import position from './components/position'
import info from './components/info'

// auther wcp
export default {
    name: "reportIndo",

    // 组件注册
    components: {
        info,
        position
    },
    data() {
        return {
            currentIndex:0, // 当前选中的navbar
            navbarList:[
                {
                    name:'勘察信息',
                },{
                    name:'设计定位'
                }
            ]
        };
    },
    props: {},
    //计算属性
    computed: {},
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        navbarChange (index) {
            this.currentIndex = index
        }
    },
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.container_wrap {
    width: 100%;
    min-height: 100vh;
    background: #F9F9FB;
    .top-title-box {
        width: 100vw;
        height: 480px;
        background: #F3F6FF;
        padding: 38px 0 0 32px;
        div:nth-child(1){
            font-size: 36px;
            font-weight: 600;
            color: #333333;
            margin-bottom: 16px;
        }
        div:nth-child(2){
            font-size: 24px;
            font-weight: 400;
            color: #555555;
        }
    }
    .content-box {
        padding:0 32px ;
        width: 100%;
        margin-top: -300px;
        .report-content {
            .navbar-box {
                margin-bottom: 16px;
                width: 100%;
                height: 80px;
                background: #FFFFFF;
                border-radius: 16px 16px 16px 16px;
                display:flex;
                position:relative;
                .navbar-item {
                    flex: 1;
                    font-size: 24px;
                    font-weight: 400;
                    transition: all 0.4s;
                    color: #A3A3A3;
                }
                .active-item {
                    font-weight: 600;
                    color: #0D53FC;
                }
                .bottom-slider {
                    transition: all 0.4s;
                    position: absolute;
                    width: 100px;
                    height: 4px;
                    background: #0D53FC;
                    bottom:0;
                    transform: translateX(-50%);
                }
            }
        }
    }
}
.navContent-enter-active,
.navContent-leave-active         {
    transition:all 0.4s;
}
.navContent-enter {
    opacity:0;
    transform:translateX(30px);
}
.navContent-leave-to {
    opacity:0;
    transform:translateX(30px);
}
</style>
